/* RESPONSIBLE TEAM: team-workflows */
import type SendToSalesforce from 'embercom/models/operator/visual-builder/step/send-to-salesforce';
import StepConfig, { type StepConfigParams } from '../step';

export default class SendToSalesforceConfiguration extends StepConfig {
  declare step: SendToSalesforce;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/send-to-salesforce',
      ...params,
    });
  }
}
